// extracted by mini-css-extract-plugin
module.exports = {"embedTopSection":"embed-top-bar_embedTopSection_3VD"};